import { useEffect, useState } from "react";
import { customersAPI, MaterialAPI, ordersAPI } from "../../services/api";

export default function AddMaterialModal({ onClose, orderId, defaultCustomerId }) {
  const [customers, setCustomers] = useState([]);
  const [materialTypes, setMaterialTypes] = useState([]);

  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [errors, setErrors] = useState({});
  const [apiError, setApiError] = useState(null);

  const [form, setForm] = useState({
    customerId: defaultCustomerId || "",
    materialId: "",
    unitType: "Pcs",
    unitCustom: "",
    quantity: "",
    amount: "",
  });

  const selectedMaterial = materialTypes.find(
    (m) => m.id == form.materialId
  );

  // LOAD DATA
 useEffect(() => {
  const loadData = async () => {
    try {
      const res = await MaterialAPI.get();

      console.log("Material API:", res);

      // ✅ DIRECTLY use materialTypes (no status check)
      const list = res?.materialTypes || [];

      const material = list.map((m) => ({
        id: Number(m.MM_ID),
        name: m.MM_Name,
        unit: m.MM_Unit,
      }));

      setMaterialTypes(material);

    } catch (e) {
      console.error("Material Load Error:", e);
      setApiError(e.message || "Failed to load data");
    } finally {
      setLoading(false);
    }
  };

  loadData();
}, []);

  const handleChange = (key) => (e) => {
  const value = e.target.value;

  setForm((prev) => {
    const updated = { ...prev, [key]: value };

    // 🔥 Auto-set unit when material selected
    if (key === "materialId") {
      const selected = materialTypes.find((m) => m.id == value);

      if (selected?.unit) {
        updated.unitType = selected.unit;
      }
    }

    return updated;
  });

  if (errors[key]) {
    setErrors((prev) => ({ ...prev, [key]: "" }));
  }
};

  // SAVE
  const handleSave = async () => {
    const e = {};

    if (!form.customerId) e.customerId = "Select customer";
    if (!form.materialId) e.materialId = "Select material";
    if (!form.quantity) e.quantity = "Enter quantity";
    if (!form.amount) e.amount = "Enter rate";

    if (form.unitType === "Other" && !form.unitCustom) {
      e.unitCustom = "Enter unit";
    }

    if (Object.keys(e).length) {
      setErrors(e);
      return;
    }

    try {
      setSaving(true);

      const payload = {
        OMD_OM_ID: orderId,
        OMD_MM_ID: Number(form.materialId),
        OMD_Qty: Number(form.quantity),
        OMD_Rate: Number(form.amount),
        OMD_Unit : form.unitType

      };

      console.log("Saving Material:", payload);

      await ordersAPI.addMaterial(payload);

      onClose();
    } catch (err) {
      console.error(err);
      setApiError("Failed to save material");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div style={styles.overlay}>
      <div style={styles.modal}>

        {/* HEADER */}
        <div style={styles.header}>
          <h2 style={{ margin: 0 }}>➕ Add Material</h2>
          <button onClick={onClose} style={styles.closeBtn}>✕</button>
        </div>

        {apiError && <div style={styles.error}>{apiError}</div>}

        {loading ? (
          <div style={styles.center}>Loading...</div>
        ) : (
          <div style={styles.body}>

            {/* CUSTOMER */}
            {/* <div style={styles.field}>
              <label style={styles.label}>Customer *</label>
              <select
                style={styles.input}
                value={form.customerId}
                onChange={handleChange("customerId")}
              >
                <option value="">Select Customer</option>
                {customers.map((c) => (
                  <option key={c.id} value={c.id}>
                    {c.name} ({c.phone})
                  </option>
                ))}
              </select>
              {errors.customerId && <div style={styles.error}>{errors.customerId}</div>}
            </div> */}

            {/* MATERIAL */}
            <div style={styles.field}>
            <label style={styles.label}>Material *</label>
            <select
              style={styles.input}
              value={form.materialId}
              onChange={handleChange("materialId")}
            >
              <option value="">Select Material</option>

              {materialTypes.length === 0 && (
                <option disabled>Loading or No data</option>
              )}

              {materialTypes.map((m) => (
                <option key={m.id} value={m.id}>
                  {m.name}
                </option>
              ))}
            </select>

            {errors.materialId && (
              <div style={styles.error}>{errors.materialId}</div>
            )}
          </div>

            {/* UNIT TYPE */}
            <div style={styles.field}>
            <label style={styles.label}>Unit *</label>
   
            <input
              style={styles.input}
              value={
                selectedMaterial?.unit || ""
              }
              readOnly
              placeholder="Auto from material"
            />
          
          </div>

            {/* CUSTOM UNIT */}
            {form.unitType === "Other" && (
              <div style={styles.field}>
                <label style={styles.label}>Enter Unit</label>
                <input
                  style={styles.input}
                  value={form.unitCustom}
                  onChange={handleChange("unitCustom")}
                  placeholder="Kg / Roll / Set"
                />
                {errors.unitCustom && <div style={styles.error}>{errors.unitCustom}</div>}
              </div>
            )}

            {/* QUANTITY */}
            <div style={styles.field}>
              <label style={styles.label}>Quantity *</label>
              <input
                type="number"
                style={styles.input}
                value={form.quantity}
                onChange={handleChange("quantity")}
              />
              {errors.quantity && <div style={styles.error}>{errors.quantity}</div>}
            </div>

            {/* RATE */}
            <div style={styles.field}>
              <label style={styles.label}>Rate *</label>
              <input
                type="number"
                style={styles.input}
                value={form.amount}
                onChange={handleChange("amount")}
              />
              {errors.amount && <div style={styles.error}>{errors.amount}</div>}
            </div>

            {/* TOTAL */}
            <div style={styles.field}>
              <label style={styles.label}>Total</label>
              <input
                style={styles.input}
                value={
                  form.quantity && form.amount
                    ? Number(form.quantity) * Number(form.amount)
                    : ""
                }
                readOnly
              />
            </div>

          </div>
        )}

        {/* FOOTER */}
        <div style={styles.footer}>
          <button style={styles.cancelBtn} onClick={onClose}>
            Cancel
          </button>
          <button
            style={styles.saveBtn}
            onClick={handleSave}
            disabled={saving}
          >
            {saving ? "Saving..." : "Save"}
          </button>
        </div>

      </div>
    </div>
  );
}

/* ================= STYLES ================= */

const styles = {
  overlay: {
    position: "fixed",
    inset: 0,
    background: "rgba(0,0,0,0.5)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 1000,
  },
  modal: {
    width: 420,
    background: "#fff",
    borderRadius: 12,
    boxShadow: "0 10px 30px rgba(0,0,0,0.2)",
    overflow: "hidden",
  },
  header: {
    padding: "16px 20px",
    borderBottom: "1px solid #eee",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  closeBtn: {
    border: "none",
    background: "transparent",
    fontSize: 18,
    cursor: "pointer",
  },
  body: {
    padding: 20,
    display: "flex",
    flexDirection: "column",
    gap: 16,
  },
  field: {
    display: "flex",
    flexDirection: "column",
  },
  label: {
    marginBottom: 6,
    fontWeight: 500,
  },
  input: {
    padding: "10px 12px",
    borderRadius: 8,
    border: "1px solid #ccc",
    fontSize: 14,
  },
  footer: {
    padding: 16,
    borderTop: "1px solid #eee",
    display: "flex",
    justifyContent: "flex-end",
    gap: 10,
  },
  cancelBtn: {
    padding: "8px 16px",
    background: "#eee",
    border: "none",
    borderRadius: 8,
    cursor: "pointer",
  },
  saveBtn: {
    padding: "8px 16px",
    background: "#4caf7a",
    color: "#fff",
    border: "none",
    borderRadius: 8,
    cursor: "pointer",
  },
  error: {
    color: "red",
    fontSize: 13,
    marginTop: 4,
  },
  center: {
    padding: 20,
    textAlign: "center",
  },
};